// import { useNavigate, useLocation } from 'react-router-dom';
// import { Grid, Card, CardContent, Typography, Stack, Button, Avatar, Box, IconButton, CircularProgress } from '@mui/material';
// import { useState, useEffect } from 'react';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { styled } from '@mui/material/styles';

// // Material Dashboard 2 React example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";

// import image040 from '../../assets/custom-icon/image040.png';
// import image041 from '../../assets/custom-icon/image041.jpg';
// import image042 from '../../assets/custom-icon/image042.jpg';

// import { url, urlLive } from "../../constant";


// // const specificRequest = {
// //   IdRequest: 3,
// //   Title: 'Tempora quia velit amet itaque labore velit.',
// //   Description: 'Quisquam distinctio nihil delectus non non. Quisquam distinctio nihil delectus non non. Quisquam distinctio nihil delectus non non. Quisquam distinctio nihil delectus non non. Quisquam distinctio nihil delectus non non.',
// //   CategoryName: 'perferendis',
// //   CompanyName: 'Lakin, DuBuque and Kling',
// //   CreationDate: '2025-01-01 08:09:30',
// //   DailyRate: 256,
// //   Location: 'South Enoch',
// //   PublishDate: '2016-05-08',
// //   ExperienceYears: 9,
// //   FullRemote: 0,
// //   LongTerm: 1,
// // };

// const RequestDetails = () => {
//   const navigate = useNavigate();
//   const [showFullDescription, setShowFullDescription] = useState(false);  // State to toggle description visibility
//   const locations = useLocation(); // Get the current URL location
//   const queryParams = new URLSearchParams(locations.search); // Extract query parameters
//   const requestId = queryParams.get('requestId'); // Get 'requestId' query parameter
//   const [specificRequest, setSpecificRequest] = useState(null);


//   // console.log(requestId);

//   // Fetch request details when the component mounts or when requestId changes
//   useEffect(() => {
//     if (requestId) {
//       // Fetch the request details from the API dynamically
//       fetch(`${url}auth/requests-details-specific/${requestId}`)
//         .then((response) => response.json())
//         .then((result) => {
//           if (result.message === "Request retrieved successfully.") {
//             console.log(result.data[0]);
//             setSpecificRequest(result.data[0]); // Store the first result in the state
//           } else {
//             console.error("Failed to retrieve request details.");
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching request details:", error);
//         });
//     }
//   }, [requestId]); // This will run whenever requestId changes

//   // Handle back button click (navigate to requests page or go back)
//   const handleBackClick = () => {
//     navigate('/dashboard/requests'); // Navigate to request listing page
//   };

//   const formatDate = (dateString) => { const date = new Date(dateString); const day = String(date.getDate()).padStart(2, '0'); const month = String(date.getMonth() + 1).padStart(2, '0'); const year = date.getFullYear(); return `${day}-${month}-${year}`; };

//   // Toggle description visibility (show more/less)
//   const handleToggleDescription = () => {
//     setShowFullDescription(!showFullDescription);
//   };

//   // Function to handle truncation of description
//   const truncatedDescription = (text, limit) => {
//     if (text.length > limit) {
//       return `${text.substring(0, limit)}...`;
//     }
//     return text;
//   };


//   // const ZoomAvatar = styled(Avatar)(({ theme }) => ({
//   //   width: { xs: 40, sm: 56 },  // Responsive Avatar size
//   //   height: { xs: 40, sm: 56 }, // Responsive Avatar size
//   //   '&:hover': {
//   //     transform: 'scale(1.2)',  // This will zoom the image on hover
//   //     transition: 'transform 0.3s ease',  // Smooth transition effect
//   //   },
//   // }));

//   // Loading or Error State
//   if (!specificRequest) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100vh',  // Full height of the viewport
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100%',
//           backgroundColor: 'rgba(255, 255, 255, 0.8)',  // Semi-transparent background
//           zIndex: 9999, // Ensure the spinner is on top of other content
//         }}
//       >
//         <CircularProgress size={60} color="secondary" />
//       </Box>
//     );
//   }

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <Grid container spacing={2} justifyContent="center" sx={{ padding: '2rem', }}>
//         {/* Request Details Card */}
//         <Grid item xs={12} sm={8} md={6} lg={8}>
//           <Card sx={{ padding: '2rem', boxShadow: 3 }}>
//             {/* Card Header */}
//             <CardContent>

//               <Stack
//                 direction={{ xs: 'column', sm: 'row' }}  // Stack vertically on mobile, horizontally on larger screens
//                 spacing={2}
//                 alignItems="center"
//                 sx={{ width: '100%' }} // Ensure it doesn't overflow
//               >
//                 <Avatar
//                   sx={{
//                     bgcolor: '#4A60AE',
//                     width: { xs: 45, sm: 56 },  // Responsive Avatar size
//                     height: { xs: 45, sm: 56 }, // Responsive Avatar size
//                   }}
//                   src={image042}
//                 >
//                   {/* {specificRequest.Title[0].toUpperCase()} */}
//                   {!image042 && specificRequest.Title[0].toUpperCase()}
//                 </Avatar>


//                 <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: 'bold',
//                       fontSize: { xs: '1.2rem', sm: '1.5rem' }, // Adjust font size on mobile
//                     }}
//                   >
//                     {specificRequest.Title}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     color="textSecondary"
//                     sx={{
//                       fontSize: { xs: '0.9rem', sm: '1rem' }, // Adjust font size on mobile
//                     }}
//                   >
//                     Published on: { formatDate(specificRequest.PublishDate)}
//                   </Typography>
//                 </Box>
//               </Stack>


//               {/* Description and Other Details */}
//               <Box mt={2}>
//                 <Typography variant="body1" paragraph>
//                   <strong>Description:</strong>
//                   <Typography
//                     variant="body2"
//                     color="textSecondary"
//                     sx={{
//                       maxHeight: showFullDescription ? 'none' : '150px',
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       lineClamp: 3,
//                       display: '-webkit-box',
//                       WebkitLineClamp: showFullDescription ? 'none' : 3,
//                       WebkitBoxOrient: 'vertical',
//                       transition: 'max-height 0.3s ease',
//                     }}
//                   >
//                     {showFullDescription ? specificRequest.Description : truncatedDescription(specificRequest.Description, 150)}
//                   </Typography>
//                   <Button
//                     onClick={handleToggleDescription}
//                     sx={{ textTransform: 'none', marginTop: 1 }}
//                     size="small"
//                     color="primary"
//                   >
//                     {showFullDescription ? 'Show Less' : 'Show More'}
//                   </Button>
//                 </Typography>

//                 {/* Display Other Details */}
//                 <Typography variant="body1" paragraph>
//                   <strong>Category:</strong> {specificRequest.CategoryName}
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Company:</strong> {specificRequest.CompanyName}
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Location:</strong> {specificRequest.Location}
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Daily Rate:</strong> ${specificRequest.DailyRate}
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Experience Required:</strong> {specificRequest.ExperienceYears} years
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Full Remote:</strong> {specificRequest.FullRemote ? 'Yes' : 'No'}
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   <strong>Long Term:</strong> {specificRequest.LongTerm ? 'Yes' : 'No'}
//                 </Typography>
//               </Box>

//               {/* Back Button */}
//               <Stack direction="row" spacing={2} justifyContent="space-between" mt={2}>
//                 {/* <IconButton onClick={handleBackClick} sx={{ color: '#4A60AE' }}>
//                   <ArrowBackIcon />
//                 </IconButton> */}
//                 <Button
//                   variant="outlined"
//                   sx={{
//                     marginTop: '1rem',
//                     borderRadius: '8px',
//                     backgroundColor: '#4A60AE',
//                     color: 'white',
//                     ':hover': { backgroundColor: '#2C3E50' },
//                   }}
//                   onClick={handleBackClick}
//                 >
//                   Back to Requests
//                 </Button>
//               </Stack>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//       <Footer />
//     </DashboardLayout>
//   );

// };

// export default RequestDetails;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Stack, Button, Avatar, Box, CircularProgress, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import image042 from '../../assets/custom-icon/image042.jpg';
import { url ,fileUploadUrl} from "../../constant";

import Link from '@mui/material/Link';
import LinkIcon from '@mui/icons-material/Link';
import AttachFileIcon from '@mui/icons-material/AttachFile';

// const serverUrl = "http://localhost:8000";

const RequestDetails = () => {
  // alert();
  const navigate = useNavigate();
  const [showFullDescription, setShowFullDescription] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestId');
  const backUrlTerm = queryParams.get('backUrlTerm');
  // console.log(requestId,backUrlTerm);
  const backTo = queryParams.get('back');
  const [specificRequest, setSpecificRequest] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [requestTypes, setRequestTypes] = React.useState([]);

  // State to track if the button is clicked
  const [isClicked, setIsClicked] = useState(false);
  const [recordExists, setRecordExists] = useState(false);

  // Get the user ID from localStorage
  const user = JSON.parse(localStorage.getItem('user')); // Assuming user data is stored in localStorage
  const userId = user.user.IdUser;
  const IsCompanyAdmin = user ? user.user.IsAdminCompany : null;
  const IsAdminPlatform = user ? user.user.IsAdminPlatform : null;


  // console.log(userId,specificRequest.CreationUser);

  useEffect(() => {

    if (requestId) {
      
      // fetch(`${url}auth/requests-details-specific/${requestId}`)
      //   .then((response) => response.json())
      //   .then((result) => {
      //     // if (result.message === "Request retrieved successfully.") {
      //     if (result.data.length) {
      //       setSpecificRequest(result.data[0]);
      //     } else {
      //       window.location.href = '/authentication/log-out';
      //       console.error("Failed to retrieve request details.");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching request details:", error);
      //   });

        fetchRequestTypes();

        
    }
    
  }, [requestId]);


  useEffect(() => {
    if (requestId && userId) {
      console.log("show specificRequest", specificRequest);

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("request_id", requestId);

      const requestOptions = {
        method: "POST",
        body: formData,
      };

      // Perform the fetch request
      fetch(`${url}auth/check-email-record`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((result) => {
          // If record exists, set the recordExists state
          setRecordExists(result.record_exists);
          setIsClicked(result.record_exists);
        })
        .catch((error) => {
          console.error("Error:", error);
          setRecordExists(false); // Set recordExists to false in case of error
        })
        .finally(() => {
          // Set loading state to false after request is complete
          setLoading(false);
        });


    }
  }, [requestId, userId]);

  const createEmailRecord = async (userId, requestId) => {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("request_id", requestId);

    const requestOptions = {
      method: "POST",
      body: formData,
      redirect: "follow",
    };

    try {
      const response = await fetch(`${url}auth/create-email-record`, requestOptions);
      const result = await response.json(); // Assuming response is JSON

      if (response.ok) {
        console.log('Record created successfully:', result.message);
        // If needed, return the result
        return result;
      } else {
        console.error('Failed to create record:', result.message);
        // Handle failure case
        return { success: false, message: 'Failed to create record.' };
      }
    } catch (error) {
      console.error("Error:", error);
      return { success: false, message: 'An error occurred while creating the record.' };
    }
  };

  const fetchRequestTypes = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-request-types`);
      const data = await response.json();
      setRequestTypes(data.data || []);

      fetch(`${url}auth/requests-details-specific/${requestId}`)
        .then((response) => response.json())
        .then((result) => {
          // if (result.message === "Request retrieved successfully.") {
          if (result.data.length) {
            setSpecificRequest(result.data[0]);
          } else {
            window.location.href = '/authentication/log-out';
            console.error("Failed to retrieve request details.");
          }
        })
        .catch((error) => {
          console.error("Error fetching request details:", error);
        });  


    } catch (error) {
      console.error("Error fetching request types:", error);
    } finally {
      setIsLoading(false);
    }

  };


  const handleBackClick = () => {    
    if (backTo) {
      window.location.href = '/dashboard/Elenco-Richieste';
    } else {
      window.location.href = '/dashboard' + atob(backUrlTerm);
    }

  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleToggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const truncatedDescription = (text, limit) => {
    if (text.length > limit) {
      return `${text.substring(0, limit)}...`;
    }
    return text;
  };

  if (!specificRequest || loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} color="secondary" />
      </Box>
    );
  }


  const sendMessage = (IdRequest, ObjectMessage, Message, CreationUser) => {
    const formdata = new FormData();
    formdata.append("IdRequest", IdRequest);
    formdata.append("ObjectMessage", JSON.stringify(ObjectMessage));
    formdata.append("Message", Message);
    formdata.append("CreationUser", CreationUser);

    const requestOptions = {
      method: "POST",
      body: formdata,

    };

    fetch(`${url}auth/create-messages`, requestOptions)
      .then((response) => response.json())
      .then((result) => console.log(result))
      .catch((error) => console.error("Error:", error));
  }


  const sendEmail = (id) => {
    var akLoginUser = JSON.parse(localStorage.getItem('user'));
    //alert(akLoginUser.user.email);
    setLoading(true);
    var formData = new FormData();
    formData.append('cc_email', akLoginUser.user.email)
    fetch(`${url}auth/send-request-email/${id}`, {
      method: 'POST',
      body: formData
    }).then(res => {
      return res.json();
    }).then(json => {
      setLoading(false);

      createEmailRecord(userId, requestId)
        .then(result => {

          if (result.success !== false) {
            console.log("Success:", result);
          } else {
            console.error("Error:", result.message);
          }

        });


      let requestData = [];

      if (specificRequest.ItDev) {
        // Send email with request details
        requestData = [
          {
            IdRequest: specificRequest.IdRequest,  // Assuming the request ID is returned in the response
            Title: specificRequest.Title,
            Description: specificRequest.Description,
            companyName: specificRequest.CompanyName,
            CategoryName: specificRequest.CategoryName,
            TypeName: specificRequest.TypeName,
            Location: specificRequest.Location,
            FullRemote: specificRequest.FullRemote,
            ExperienceYears: specificRequest.ExperienceYears,
            DailyRate: specificRequest.DailyRate,
            DateStartAvailable: specificRequest.DateStartAvailable ? specificRequest.DateStartAvailable : '',
            DateEndAvailable: specificRequest.DateEndAvailable ? specificRequest.DateStartAvailable : '',
            LongTerm: specificRequest.LongTerm,
            PublishDate: specificRequest.PublishDate,
          }
        ];

      } else {
        // Send email with request details
        requestData = [

          {
            IdRequest: specificRequest.IdRequest,  // Assuming the request ID is returned in the response
            Title: specificRequest.Title,
            Description: specificRequest.Description,
            companyName: specificRequest.CompanyName,
            CategoryName: specificRequest.CategoryName,
            TypeName: specificRequest.TypeName,
            PublishDate: specificRequest.PublishDate,
          }

        ];

      }

      sendMessage(requestId, requestData, "User request details", userId);

      alert(json.message);
    })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={2} justifyContent="center" sx={{ padding: '2rem' }}>
        <Grid item xs={12} sm={8} md={6} lg={8}>
          <Card sx={{ padding: '2rem', boxShadow: 3 }}>
            <CardContent>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                sx={{ width: '100%' }}
              >
                <Avatar
                  sx={{
                    bgcolor: '#4A60AE',
                    width: { xs: 45, sm: 56 },
                    height: { xs: 45, sm: 56 },
                  }}
                  src={image042}
                >
                  {!image042 && specificRequest.Title[0].toUpperCase()}
                </Avatar>
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: { xs: '1.2rem', sm: '1.5rem' },
                    }}
                  >
                    {specificRequest.Title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                    }}
                  >
                    {/* Published on: {formatDate(specificRequest.PublishDate)} */}
                    pubblicata il: {formatDate(specificRequest.PublishDate)}
                  </Typography>
                </Box>
              </Stack>
              <Box mt={2}>
                <Typography variant="body1" paragraph>
                  {/* <strong>Description:</strong> */}
                  <strong>Descrizione:</strong>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      // maxHeight: showFullDescription ? 'none' : '150px',
                      // overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                      // lineClamp: 3,
                      // display: '-webkit-box',
                      // WebkitLineClamp: showFullDescription ? 'none' : 3,
                      // WebkitBoxOrient: 'vertical',
                      // transition: 'max-height 0.3s ease',
                      whiteSpace: 'pre-line',
                      // other styles can stay commented or active as needed
                    }}
                  >
                    {/* {showFullDescription ? specificRequest.Description : truncatedDescription(specificRequest.Description, 150)} */}
                    {specificRequest.Description}
                  </Typography>
                  {/* <Button
                    onClick={handleToggleDescription}
                    sx={{ textTransform: 'none', marginTop: 1 }}
                    size="small"
                    color="primary"
                  >
                    {showFullDescription ? 'Show Less' : 'Show More'}
                  </Button> */}
                </Typography>
                <Typography variant="body1" paragraph>
                  {/* <strong>Category:</strong> {specificRequest.CategoryName} */}
                  <strong>Categoria:</strong> {specificRequest.CategoryName}
                </Typography>
                <Typography variant="body1" paragraph>
                  {/* <strong>Type:</strong> {specificRequest.TypeName} */}
                  <strong>Tipologia:</strong> {specificRequest.TypeName}
                </Typography>
                {/* <Typography variant="body1" paragraph>
                  <strong>Company:</strong> {specificRequest.CompanyName}
                  <strong>Azienda:</strong> {specificRequest.CompanyName}
                </Typography> */}
                {IsAdminPlatform == 1 && (
                  <Typography variant="body1" paragraph>
                    <strong>Azienda:</strong> {specificRequest.CompanyName}
                  </Typography>
                )}

                {/* <Typography variant="body1" paragraph>
                  <strong>Attachment: </strong>
                  {specificRequest.attachment ? (
                   
                    <Link
                      onClick={() => window.open(`${fileUploadUrl}/${specificRequest.attachment ?? null}`, '_blank')}
                    >
                      {specificRequest.attachment}
                    </Link>

                  ) : (
                    ' No attachment available.'
                  )}
                </Typography> */}
                 
                 {/* specificRequest.ItDev  */}
                {requestTypes.find( x => x.IdRequestType == specificRequest.IdTypeRequest).ItDev ? (

                  <>

                    <Typography variant="body1" paragraph>
                      {/* <strong>Location:</strong> {specificRequest.Location} */}
                      <strong>Luogo:</strong> {specificRequest.Location}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {/* <strong>Daily Rate:</strong> ${specificRequest.DailyRate} */}
                      <strong>Rate giornaliero:</strong> {specificRequest.DailyRate}€
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {/* <strong>Experience Required:</strong> {specificRequest.ExperienceYears} years */}
                      <strong>Esperienza:</strong> {specificRequest.ExperienceYears} Anni
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Full Remote:</strong> {specificRequest.FullRemote ? 'Si' : 'No'}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {/* <strong>Long Term:</strong> {specificRequest.LongTerm ? 'Yes' : 'No'} */}
                      <strong>Lunga durata:</strong> {specificRequest.LongTerm ? 'Si' : 'No'}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {/* <strong>Start Date Available:</strong> {formatDate(specificRequest.DateStartAvailable)} */}
                      <strong>Data inizio prevista:</strong> { specificRequest.DateStartAvailable == null ? '' : formatDate(specificRequest.DateStartAvailable) }
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {/* <strong>End Date Available:</strong> {formatDate(specificRequest.DateEndAvailable)} */}
                      <strong>Data fine prevista:</strong> {specificRequest.DateEndAvailable == null ? '' : formatDate(specificRequest.DateEndAvailable)}
                    </Typography>

                  </>

                ) : ''}

                {
                  specificRequest.attachment ? (<Typography sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} variant="body1" paragraph>
                    {/* <strong>Attachment: </strong> */}
                    <strong>Allegato: </strong>
                    {specificRequest.attachment ? (

                      <Link
                        onClick={() => window.open(`${fileUploadUrl}/${specificRequest.attachment ?? null}`, '_blank')}
                        sx={{cursor: 'pointer', marginLeft: '3px'}}
                      >
                        {/* {specificRequest.attachment.split("/")[1]} */}
                        {specificRequest.attachment_name}
                        {/* <AttachFileIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} /> */}
                      </Link>

                    ) : (
                      ' No attachment available.'
                    )}
                  </Typography>) : null
                }

                {/* {
                  specificRequest.LinkUrl ? (<Typography sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} variant="body1" paragraph>
                    <strong>Attachment: </strong>
                    <strong>Collegamento: </strong>
                    {specificRequest.LinkUrl ? (

                      <Link
                        onClick={() => window.open(`${specificRequest.LinkUrl ?? null}`, '_blank')}
                        sx={{cursor: 'pointer', marginLeft: '3px'}}
                      >
                        {specificRequest.LinkDescription}
                        <LinkIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} />
                      </Link>

                    ) : (
                      ' No link available.'
                    )}
                  </Typography>) : null
                } */}

                {/* <strong>Descrizione Collegamento: </strong> */}
                {
                  specificRequest.LinkUrl ? (
                    <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-line', }} >
                      {/* <strong>Attachment: </strong> */}
                      <strong>Descrizione Collegamento: </strong>
                      {specificRequest.LinkUrl ? (

                        <Link
                          onClick={() => window.open(`${specificRequest.LinkUrl ?? null}`, '_blank')}
                          sx={{ cursor: 'pointer', marginLeft: '3px' }}
                          color="textSecondary"
                        >
                          {specificRequest.LinkDescription}

                        </Link>

                      ) : (
                        ' No link available.'
                      )}
                    </Typography>) : null
                }


                {/* <Typography variant="body1" paragraph>
                  <strong>Creation Date:</strong> {formatDate(specificRequest.CreationDate)}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Creation User:</strong> {specificRequest.CreationUser}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Update Date:</strong> {formatDate(specificRequest.UpdateDate)}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Update User:</strong> {specificRequest.UpdateUser}
                </Typography> */}
              </Box>
              <Stack direction="row" spacing={2} justifyContent="space-between" mt={2}>

                <span>
                  <Button
                    variant="outlined"
                    sx={{
                      marginTop: '1rem',
                      borderRadius: '8px',
                      // backgroundColor: '#4A60AE',
                      // backgroundColor: 'hsl(210 100% 20%)',
                      backgroundColor: '#183759',
                      color: 'white',
                      ':hover': { backgroundColor: '#2C3E50' },
                      // height: '45px', // Ensure height is consistent for both buttons
                    }}
                    onClick={handleBackClick}
                  >
                    {/* Back to Requests */}
                    Torna alle Richieste
                  </Button>
                </span>
                {
                (userId !== specificRequest.CreationUser) && 
                !!(IsAdminPlatform || IsCompanyAdmin) && (

                  <Tooltip
                    title={isClicked ? 'Email already sent' : ''}
                    arrow
                  // placement="top" // This ensures the tooltip shows at the top
                  >
                   
                        <span>
                          <Button
                            variant="outlined"
                            color="success"
                            sx={{
                              display: (specificRequest.CompanyIsActive) ? "block" : 'none',
                              marginTop: '1rem',
                              borderRadius: '8px',
                              backgroundColor: '#66bb6a',
                              color: 'white',
                              ':hover': { backgroundColor: '#388e3c' },
                              // height: '8px', // Ensure height is consistent for both buttons
                            }}
                            disabled={isClicked} // Disable the button once clicked
                            onClick={() => {
                              sendEmail(specificRequest.IdRequest)
                              // Disable the button after click
                              setIsClicked(true);
                            }}
                          >

                            {isClicked ? 'Mail inviata' : 'Richiedi info'} {/* Conditionally change text */}
                          </Button>
                        </span>
                     
                  </Tooltip>

                )}

              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );

};

export default RequestDetails;
